import Chat from "@/pages/Chat";
import {selectedCompanyIdAtom} from "@/store/jotaiAtoms";
import {createFileRoute} from "@tanstack/react-router";
import {zodValidator} from "@tanstack/zod-adapter";
import {getDefaultStore} from "jotai";
import {z} from "zod";

export const Route = createFileRoute(
  "/_authenticated/_agency/agency/$agencyId/chat/$companyId/{-$campaignId}/{-$influencerUserId}",
)({
  component: Chat,
  params: {
    parse: raw => ({
      agencyId: +raw.agencyId,
      companyId: +raw.companyId,
      campaignId: raw.campaignId ? +raw.campaignId : undefined,
      influencerUserId: raw.influencerUserId ? +raw.influencerUserId : undefined,
    }),
    stringify: params => ({
      agencyId: params.agencyId?.toString(),
      companyId: params.companyId?.toString(),
      campaignId: params.campaignId?.toString(),
      influencerUserId: params.influencerUserId?.toString(),
    }),
  },
  validateSearch: zodValidator(
    z.object({
      isBulk: z.boolean().optional(),
      isNeedsReply: z.boolean().optional(),
      search: z.string().optional(),
    }),
  ),
  loader: () => {
    getDefaultStore().set(selectedCompanyIdAtom, null);
  },
});
